import { Component, OnInit } from '@angular/core';
import { PorteBeneficiario } from 'src/app/model/porte-beneficiario-model';
import { PorteBeneficiarioService } from '../porte-beneficiario.service';
import { EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ResultadoPaginado } from 'src/app/model/resultado';

@Component({
    selector: 'app-porte-beneficiario-pesquisa',
    templateUrl: './porte-beneficiario-pesquisa.component.html',
    styleUrls: ['./porte-beneficiario-pesquisa.component.scss'],
    standalone: false
})
export class PorteBeneficiarioPesquisaComponent implements OnInit {

  public portes: PorteBeneficiario[] = [];
  public pesquisado: boolean = false;
  public atributosPaginacaoComponenteListagem: EntityPagedResult<PorteBeneficiario>
  public opcoesPaginacao: number[];

  constructor(private porteBeneficiarioService: PorteBeneficiarioService) { }

  async ngOnInit() {
    this.opcoesPaginacao = [10, 20, 30];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
    await this.paginar();
  }

  public mudancaPagina(novaPagina: EntityPagedResult<PorteBeneficiario>){
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.paginar();
  }

  public async paginar() {
    this.pesquisado = false;
    this.porteBeneficiarioService.listarTodos(this.atributosPaginacaoComponenteListagem.page, 
      this.atributosPaginacaoComponenteListagem.pageSize).subscribe((resultado: ResultadoPaginado<PorteBeneficiario>) => {
        this.portes = resultado.resultados;
        this.pesquisado = true
      })
  }

}
